import {h} from 'vue';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js'; // ajuste le chemin selon ton projet

const fullConfig = resolveConfig(tailwindConfig);
export default {
  setup() {
    return {loader: undefined};
  },
  methods: {
    showLoader(
      ref,
      canCancel = false,
      backgroundColor = fullConfig.theme.colors.secondary['50'],
      color = fullConfig.theme.colors.primary['600'],
    ) {
      this.loader = this.$loading.show({
        container: ref,
        canCancel: canCancel,
        backgroundColor: backgroundColor,
        color: color,
        isFullPage: false,
      });
    },
    showTotalLoader(
      canCancel = false,
      backgroundColor = fullConfig.theme.colors.secondary['50'],
      color = fullConfig.theme.colors.primary['600'],
      after = '',
    ) {
      this.loader = this.$loading.show(
        {
          canCancel: canCancel,
          backgroundColor: backgroundColor,
          color: color,
          isFullPage: true,
          opacity: 1,
        },
        {
          // Pass slots by their names
          after: after !== '' ? h('span', {class: 'loader-message'}, after) : undefined,
        },
      );
    },
    showTotalLoaderGuestadom(
      canCancel = false,
      backgroundColor = 'var(--color-white)',
      color = fullConfig.theme.colors.tertiary['DEFAULT'],
      after = '',
    ) {
      this.loader = this.$loading.show(
        {
          canCancel: canCancel,
          backgroundColor: backgroundColor,
          color: color,
          isFullPage: true,
          opacity: 1,
        },
        {
          // Pass slots by their names
          before: () => h('span', {class: 'guestadom-logo-loader'}),
          after: after !== '' ? () => h('span', {class: 'loader-message'}, after) : undefined,
        },
      );
    },
    showTotalLoaderWithAfter(
      after,
      canCancel = false,
      backgroundColor = fullConfig.theme.colors.secondary['50'],
      color = fullConfig.theme.colors.tertiary['DEFAULT'],
    ) {
      this.loader = this.$loading.show(
        {
          canCancel: canCancel,
          backgroundColor: backgroundColor,
          color: color,
          isFullPage: true,
        },
        {
          after: after !== '' ? () => h('span', {class: 'loader-message'}, after) : undefined,
        },
      );
    },
    showRefLoaderWithAfter(
      ref,
      after,
      canCancel = false,
      backgroundColor = fullConfig.theme.colors.secondary['50'],
      color = fullConfig.theme.colors.tertiary['DEFAULT'],
    ) {
      this.loader = this.$loading.show(
        {
          container: ref?.$el ?? ref,
          canCancel: canCancel,
          backgroundColor: backgroundColor,
          color: color,
          isFullPage: true,
        },
        {
          after: after !== '' ? () => h('span', {class: 'loader-message'}, after) : undefined,
        },
      );
    },
    hideLoader() {
      if (this.loader) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  },
  unmounted() {
    if (this.loader) {
      this.loader.hide();
      this.loader = undefined;
    }
  },
};
